(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ROR.Validate",
                {
                    url: "/Validate",
                    component: "validate",
                    PageTitle: "Validate Personal Information",
                    //requiredPermissions: "NewAccountWizard:View"    
                    resolve: {      
                        userMasterAdvisorAgreement: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getLoggedInUserMasterAdvisorAgreement().then(function (agreement) {
                                return agreement;
                            }, function () {
                                return null;
                            });
                        }],
                        userOnbordingRecord: ["onboardingApi", function (onboardingApi) {                            
                            return onboardingApi.getLoggedInUserOnboarding().then(function (record) {
                                return record;
                            }, function () {
                                return null;
                            });
                        }],
                        rorSteps: ["masterAdvisorAgreementRequiredRecord", "userOnbordingRecord", "userMasterAdvisorAgreement", function (masterAdvisorAgreementRequiredRecord, userOnbordingRecord, userMasterAdvisorAgreement) {
                            var steps = [];

                            if (userOnbordingRecord != null) {
                                if (masterAdvisorAgreementRequiredRecord != null)
                                    steps.push({
                                        step: "agreement",
                                        description: "Sign Master Advisor Agreement",
                                        complete: userMasterAdvisorAgreement != null ? true : false
                                    });

                                steps.push({
                                    step: "validate",
                                    description: "Validate your Personal Information",
                                    complete: userOnbordingRecord.InfoValidated != null ? true : false
                                });

                                steps.push({
                                    step: "getcontracted",
                                    description: "Get Contracted!",
                                    complete: false
                                });
                            }
                            return steps;
                        }],
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("validate",
        {
            templateUrl: "App/RORWizard/Validate/validate.html",
            controller: validateCtrl,
            bindings: {          
                user: "<",
                states: "<",
                rorSteps: "<"
            }
        });

    validateCtrl.$inject = ["$http", "permissionService", "$timeout", "$filter", "$state", "onboardingApi"];

    function validateCtrl($http, permissionService, $timeout, $filter, $state, onboardingApi) {
        var $ctrl = this;      
        $ctrl.goToAgreement = ($filter('filter')($ctrl.rorSteps, { step: "agreement" }).length && $filter('filter')($ctrl.rorSteps, { step: "agreement" })[0].complete === false) ? true : false;

        
        $ctrl.UI = {};
        $ctrl.UI.currentStage = "intro";
        $ctrl.UI.prevStage = $ctrl.goToAgreement ? "agreement" : "steps";
        $ctrl.UI.nextStage = "personal";     

        var init = function () {

            onboardingApi.getUsersArcInfo().then(function (result) {
                console.log(result);                 
                result.PhoneNumber = result.PhoneNumber
                        ? result.PhoneNumber.replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, '$1-$2-$3')
                        : null;
                    $ctrl.UI.formInfo = result;
            },
            function error(x) {
                console.log(x);
            });
                 
            $(".wizard-header").removeClass("fade-right");
            $(".wizard-step").removeClass("fade-right");
            $(".prev-button").removeClass("fade-left");
            $(".next-button").removeClass("fade-right");           
        }

        $ctrl.changeStage = function(goToStage, isNext) {

            $ctrl.UI.currentStage = goToStage;

            if (goToStage === "contract") {
                $ctrl.saveInfo();
            }

            if (goToStage === "agreement") {
                $state.go("Home.ROR.Agreement", { "workflow": "ror" });
            }

            if (goToStage === "steps") {
                $state.go("Home.ROR.Steps");
            }

            if (goToStage === "personal" && isNext) {
                $(".intro-header").removeClass("fade-left");
                $(".personal").addClass("fade-right");
                $(".basic-header").addClass("fade-right");
                $ctrl.UI.prevStage = "intro";
                $ctrl.UI.nextStage = "contact";
            } else {
                $(".personal").addClass("fade-left");
                $(".contact").removeClass("fade-right");
                $(".basic-header").addClass("fade-left");
                $(".contact-header").removeClass("fade-right").removeClass("fade-left");
                $ctrl.UI.prevStage = "intro";
                $ctrl.UI.nextStage = "contact";
            }

            if (goToStage === "contact") {
                $(".contact").addClass("fade-right");
                $(".personal").removeClass("fade-left").removeClass("fade-right");
                $(".basic-header").removeClass("fade-left").removeClass("fade-right");
                $(".contact-header").addClass("fade-right");
                $ctrl.UI.prevStage = "personal";
                $ctrl.UI.nextStage = "contract";
            }

            if (goToStage === "intro") {
                $(".intro-header").addClass("fade-left");
                $(".personal").removeClass("fade-right").removeClass("fade-left");
                $(".basic-header").removeClass("fade-left").removeClass("fade-right");
                $ctrl.UI.prevStage = $ctrl.goBackToAgreement ? "agreement" : "steps";
                $ctrl.UI.nextStage = "personal";
            }
        };


        $ctrl.saveInfoTest = function() {

            console.log("save info");
            //for testing
            var record = onboardingApi.getOnBordingTestRecord();
            record.InfoValidated = new Date();
            onboardingApi.setOnBordingTestRecord(record)


            ///save.then(function()({ go to contract page });
            $state.go("Home.ROR.Contract", { "workflow": "ror" });
        };

        $ctrl.saveInfo = function() {

            onboardingApi.updateUsersArcInfo($ctrl.UI.formInfo).then(function(result) {
                    //console.log(result);                 
                },
                function error(x) {
                    console.log(x);
                }).then(onboardingApi.updateUserOnboarding().then(function(result) {
                    //console.log(result);
                    $state.go("Home.ROR.Contract", { "workflow": "ror" });
                },
                function error(x) {
                    console.log(x);
                }));
        };

        $timeout(function () {
            init();
        },1000);       
    }
})(window.app, window.angular); // jshint ignore:line